<template>
    <div>
        <div class="row">
            <div class="column-sidebar-left">
                <MessageMenu v-if="isMounted" v-on:show-content="onShowContent" v-on:go-to-message="goToMessage"></MessageMenu>
            </div>
            <div class="column-main-right">
                <component :is="contentComponent" :showMessage="messageToShow"></component>
            </div>
        </div>
    </div>
</template>

<script>

    import MessageMenu from '../../components/Messages/MessageMenu.vue'
    import MessageNew from '../../components/Messages/MessageNew.vue'
    import MessagesReceived from '../../components/Messages/MessagesReceived.vue'
    import MessagesSent from '../../components/Messages/MessagesSent.vue'
    import common from '../../modules/common'
    

    export default {

        data() {
            return {
                isMounted: false,
                contentComponent: MessageNew,
                messageToShow: null,
            }
        },
        components: {
            MessageMenu,
            MessageNew,
            MessagesReceived,
            MessagesSent
        },
        methods: {
            onShowContent: function(contentType) {
                //alert('showing content: ' + contentType);
                this.messageToShow = null;
                switch (contentType) {
                    case 'new': this.contentComponent = MessageNew; break;
                    case 'received': this.contentComponent = MessagesReceived; break;
                    case 'sent': this.contentComponent = MessagesSent; break;
                }                
            },
            cancel() {
              window.location.reload();
            },
            goToMessage(messageId) {
                this.messageToShow = messageId;
            },
        },
        mounted() {
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { url: '/messages', text: 'Messages' }
            ]);
            this.$store.dispatch("breadcrumb", bc);
            this.isMounted = true;
        }

    }

</script>